export const BULK_ENQUIRY_URL =
  process.env.REACT_APP_BULK_ENQUIRY_URL || "https://forms.gle/your-form-id";

export const openEnquiry = (url = BULK_ENQUIRY_URL) => {
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
};
